import { villagersApi } from '../api/modules/villagers.api';
import { getApiErrorMessage } from '../api/client';
import { USE_API } from '../config/api';
import { peopleMasterSeed } from '../data/master/people';
import { mapPaginated, villagerFromApi, villagerToApi } from '../models';

export async function listVillagers(params = {}) {
  if (!USE_API) {
    let items = [...peopleMasterSeed];
    if (params.search) {
      const q = String(params.search).toLowerCase();
      items = items.filter(
        (p) =>
          p.fullName?.toLowerCase().includes(q) ||
          p.peopleId?.toLowerCase().includes(q) ||
          p.mobile?.includes(q),
      );
    }
    const page = params.page || 1;
    const pageSize = params.pageSize || items.length || 10;
    const start = (page - 1) * pageSize;
    return {
      items: items.slice(start, start + pageSize),
      total: items.length,
      page,
      pageSize,
    };
  }
  try {
    const result = await villagersApi.list(params);
    return mapPaginated(result, villagerFromApi);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load villagers'));
  }
}

export async function getVillager(id) {
  if (!USE_API) {
    return peopleMasterSeed.find((p) => p.peopleId === id) || null;
  }
  try {
    return villagerFromApi(await villagersApi.getById(id));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load villager'));
  }
}

export async function createVillager(ui) {
  if (!USE_API) throw new Error('Create villager requires API mode');
  try {
    return villagerFromApi(await villagersApi.create(villagerToApi(ui)));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to create villager'));
  }
}

export async function updateVillager(id, ui) {
  if (!USE_API) throw new Error('Update villager requires API mode');
  try {
    return villagerFromApi(await villagersApi.update(id, villagerToApi(ui)));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to update villager'));
  }
}

/** Link / clear the villager profile photo without rewriting other fields. */
export async function setVillagerPhotoDocument(id, photoDocumentId) {
  if (!USE_API) throw new Error('Update villager requires API mode');
  try {
    return villagerFromApi(await villagersApi.update(id, { photoDocumentId }));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to link villager photo'));
  }
}

export async function updateVillagerKyc(id, body) {
  if (!USE_API) throw new Error('Update villager KYC requires API mode');
  try {
    return villagerFromApi(await villagersApi.updateKyc(id, body));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to update villager KYC'));
  }
}

export async function deleteVillager(id) {
  if (!USE_API) throw new Error('Delete villager requires API mode');
  try {
    await villagersApi.remove(id);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to delete villager'));
  }
}
